/**
 * Réglages › Données: how long the org keeps what it collected.
 */
import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { Button } from "@gately/ui/button";
import { Input } from "@gately/ui/input";
import { SettingRow, SettingsSection } from "@gately/ui/settings";
import { toast } from "@gately/ui/toast";

import { orpc } from "~/lib/orpc";
import { useMe } from "~/lib/use-me";

export const Route = createFileRoute("/_dashboard/reglages/donnees")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(orpc.me.get.queryOptions()),
  component: DonneesTab,
});

function DonneesTab() {
  const me = useMe();

  return (
    <VisitorRetentionSection
      key={`visitor-retention-${me.activeOrg?.id ?? "no-org"}`}
    />
  );
}

function VisitorRetentionSection() {
  const me = useMe();
  const qc = useQueryClient();
  const current = me.activeOrg?.visitorRetentionMonths ?? 12;
  const [months, setMonths] = useState(String(current));
  const save = useMutation(
    orpc.organization.setVisitorRetention.mutationOptions({
      onSuccess: () => {
        toast.success("Durée de conservation enregistrée.");
        void qc.invalidateQueries({ queryKey: orpc.me.get.key() });
      },
      onError: () => toast.error("Valeur invalide (entre 3 et 36 mois)."),
    }),
  );
  const n = Number(months);
  const valid = Number.isInteger(n) && n >= 3 && n <= 36;
  return (
    <SettingsSection
      title="Conservation des coordonnées visiteurs"
      hint="Un visiteur sans visite ni pass actif depuis ce délai est supprimé du répertoire. Les visiteurs favoris ou bloqués sont conservés."
    >
      <SettingRow label="Durée de conservation" htmlFor="visitor-retention">
        <div className="flex items-center gap-3">
          <Input
            id="visitor-retention"
            type="number"
            min={3}
            max={36}
            value={months}
            onChange={(e) => setMonths(e.target.value)}
            className="w-24"
          />
          <span className="text-sm text-neutral-500">mois</span>
        </div>
      </SettingRow>

      <Button
        disabled={!valid || n === current || save.isPending}
        onClick={() => save.mutate({ months: n })}
      >
        Enregistrer
      </Button>
    </SettingsSection>
  );
}
